import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Contact } from '../../../../shared/model';
import { SystemSelectService } from '../../system-select/system-select.service';
import { FunctionContactService, ZoneFunctionContactService } from '../../camtl.service';


import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'app-camtl-zone-contacts',
  templateUrl: './camtl-zone-contacts.component.html',
  // styleUrls: ['./camtl-zone-contacts.component.scss']
})
export class CamtlZoneContactsComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private functionContactService: FunctionContactService,
    private zoneFunctionContactService: ZoneFunctionContactService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private cgpAlertDialogService: CgpAlertDialogService
  ) { }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  gridFilter: boolean;
  editForm: FormGroup;
  private isNew: boolean = false;
  editDataItem: Contact;
  system: any;
  private functionId: any;
  private zoneContactId: any;

  ngOnInit() {
    var self = this;

    this.systemSelectService.system$
      .subscribe(system => {
        this.system = system;
        if (this.system) {
          this.zoneContactId = this.system.Id;
        }
        else {
          this.zoneContactId = undefined;
        }
        this.refresh();
      });

    this.systemSelectService.get();

    this.editForm = this.formBuilder.group({
      SystemId: [""],
      ContactId: ["", Validators.required],
      FunctionId: [""]
    })
  }

  refresh() {
    this.gridFilter = !this.gridFilter;
  }

  onRead = () => {
    var self = this;
    if (this.zoneContactId) {
      return this.zoneFunctionContactService.read("/" + this.zoneContactId, true).then(function (dataItem) {
        for (var i = 0; i < dataItem.length; i++) {
          if (dataItem[i].Required) {
            dataItem[i].Description = dataItem[i].Description;
          }
        }
        return dataItem;
      });
    }
    return Promise.resolve([]);
  }

  onEdit(object) {
    this.functionId = object.dataItem.Id;
    this.functionContactService.read("/" + this.functionId + "?$filter=IsActive eq true", true);
  }

  onSave = (dataItem) => {
    var self = this;
    dataItem.SystemId = this.system.Id;
    dataItem.FunctionId = this.functionId;

    this.zoneFunctionContactService.save(dataItem, true).then(function () {
      self.grid.refresh(true);
      self.cgpSnackbarService.showSnackbar({
        message: "Contact has been assigned",
        duration: 2000
      })
    })
  }

  onDelete = (dataItem) => {
    var self = this;
    if (dataItem.Required) {
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'A contact is mandatory for this field. Please edit contact if change is required.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else if (dataItem.ContactName == "" || dataItem.ContactName == " " || dataItem.ContactName == null) {
      self.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'Cannot delete an empty contact field.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else {
      dataItem.FunctionId = this.functionId;
      this.zoneFunctionContactService.remove("/" + dataItem.ContactId + "/" + dataItem.ProgramId + "/" + dataItem.Id).then(function () {
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: "Contact has been deleted",
          duration: 2000
        })
      })
    }
  }

  columns: any[] =
    [
      {
        field: "Description",
        title: "Function",
        checkRequired: true
      },
      {
        field: "ContactName",
        title: "Name"
      }
    ]

  template = {
    controls: {
      add: false,
      edit: true,
      delete: true,
      excel: true
    },
    columns: this.columns,
    service: this.zoneFunctionContactService,
    fileName: "zoneContacts.xlsx",
    save: this.onSave,
    delete: this.onDelete,
    read: this.onRead
  };

  formDialog = {
    title: "Contact",
    formControls: [
      {
        type: 'combobox',
        name: 'ContactId',
        title: 'Name',
        textField: 'ContactName',
        valueField: 'ContactId',
        placeholder: 'Select Contact...',
        service: this.functionContactService,
        sync: true
      }
    ]
  }
}
